export enum States {
	NoChanges,
	New,
	Edit,
	Delete,
	Link,
	Unlink,
	LinkAndEdit
}